import { cn } from '@/utils/cn';

interface StepIndicatorProps {
  currentStep: number;
  onAISparkleClick: () => void;
}

export function StepIndicator({ currentStep, onAISparkleClick }: StepIndicatorProps) {
  return (
    <div className="flex items-center gap-2 sm:gap-4 mb-8">
      <div className="flex items-center gap-2">
        <span className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full sm:text-sm text-xs",
          currentStep >= 1 ? "bg-emerald-800 text-white" : "border border-slate-300 text-slate-400"
        )}>1</span>
        <span className={cn("sm:text-sm text-xs", currentStep >= 1 ? "text-slate-800" : "text-slate-400")}>Thông tin đề xuất</span>
      </div>
      <div className="h-px w-8 sm:w-12 bg-slate-200"></div>
      <div className="flex items-center gap-2">
        <span className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full sm:text-sm text-xs",
          currentStep >= 2 ? "bg-emerald-800 text-white" : "border border-slate-300 text-slate-400"
        )}>2</span>
        <span className={cn("sm:text-sm text-xs", currentStep >= 2 ? "text-slate-800" : "text-slate-400")}>Nội dung đề xuất</span>
      </div>
      <div className="h-px w-8 sm:w-12 bg-slate-200"></div>
      <div className="flex items-center gap-2">
        <span className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full sm:text-sm text-xs",
          currentStep >= 3 ? "bg-emerald-800 text-white" : "border border-slate-300 text-slate-400"
        )}>3</span>
        <span className={cn("sm:text-sm text-xs", currentStep >= 3 ? "text-slate-800" : "text-slate-400")}>Đính kèm & gửi duyệt</span>
      </div>

      <div className="ml-auto">
        <button 
          onClick={onAISparkleClick}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-100 transition-all border border-emerald-100 sm:text-sm text-xs"
        >
          <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
          <span className="">AI Assist</span>
        </button>
      </div>
    </div>
  );
}
